import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { TableWrapComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-referer-patients",
	imports: [COMMON_IMPORTS, TableWrapComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-table-wrap fieldsStr="name">
			@for (row of rows; track row) {
				<tr>
					<td>{{ row.name }}</td>
				</tr>
			}
		</app-table-wrap>
	`,
})
export class RefererPatientsComponent extends Modalable {
	@Input() id: number
	rows: any[] = []

	async ngOnInit() {
		this.rows = this.store.removeDecArr(
			await this.apiService.post("get_patients_by_referer", {
				id: this.id,
			})
		)
		console.log(this.id)
	}
}
